/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Footer_Copyright_Short1Inputs */

const vi_sitesettings_footer_copyright_short1 = /** @type {(inputs: Sitesettings_Footer_Copyright_Short1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng bản quyền (điện thoại)`)
};

/**

* @param {Sitesettings_Footer_Copyright_Short1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_footer_copyright_short1 = /** @type {((inputs?: Sitesettings_Footer_Copyright_Short1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Footer_Copyright_Short1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_footer_copyright_short1(inputs)
});
export { sitesettings_footer_copyright_short1 as "siteSettings_footer_copyright_short" }